<div id="beyond">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Examination</h4>
                  <div class="card-body">
                    <p class="inner-lead">At our school, we understand the importance of assessments and examinations in measuring student progress and providing feedback for growth and improvement. Our examination programme includes regular formative assessments and end-of-term summative assessments that are aligned with our rigorous academic standards. Our assessments are designed to provide a comprehensive evaluation of their knowledge and skills in each subject.
                    </p>  
                    <p class="inner-lead">We understand that assessments and examinations can sometimes be stressful for students, which is why we strive to create a supportive and nurturing environment during these times. We provide our students with the necessary resources and support to help them prepare for assessments and manage any stress or anxiety associated with them. We believe that our examination program is a critical component of our academic program, providing our students with the tools they need to succeed both in the classroom and beyond.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>